var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cue-pads"},[_c('div',{staticClass:"cue-pads__pads cue-pads__pads--notes"},_vm._l((_vm.notes),function(note){return _c('cue-pad',{key:note,attrs:{"noteNr":_vm.NoteIndex(note),"note":note}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }